import DashboardCount from "../../slices/dashboard/DashboardCount";
import InventoryDashboard from "../../slices/dashboard/InventoryDashboard";
import AssetsDashboard from "../../slices/dashboard/AssetsDashboard";
import MaintenanceDashboard from "../../slices/dashboard/MaintenanceDashboard";
import AmcDashboard from "../../slices/dashboard/AmcDashboard";
import ProductionDashboard from "../../slices/dashboard/ProductionDashboard";

const dashboardReducer = {
    dashboardCount: DashboardCount,
    inventoryDashboard: InventoryDashboard,
    assetsDashboard: AssetsDashboard,
    maintenanceDashboard: MaintenanceDashboard,
    amcDashboard: AmcDashboard,
    productionDashboard: ProductionDashboard,
};

export default dashboardReducer;